import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'EMISION',
      Nombre: i18n.t('tipos.origen.emision')
    },
    {
      id: 'API',
      Nombre: i18n.t('tipos.origen.api')
    },
    {
      id: 'PORTAL',
      Nombre: i18n.t('tipos.origen.portal')
    },
    {
      id: 'RECTIFICATIVA',
      Nombre: i18n.t('tipos.origen.rectificativa')
    },
    {
      id: 'PROFORMA',
      Nombre: i18n.t('tipos.origen.proforma')
    },
    {
      id: 'PRESUPUESTO',
      Nombre: i18n.t('tipos.origen.presupuesto')
    },
    {
      id: 'SIMPLIFICADA',
      Nombre: i18n.t('tipos.origen.simplified')
    }
  ]
}

export function TIPOS_ORIGEN_FACTURA (state) {
  return configHelper.getConfig(state, 'TIPOS_ORIGEN_FACTURA', GenerateConfig)
}
